import { RegistryCategory } from '../RegistryCategory';
export class TraitRegistryCategory extends RegistryCategory {
    get registryRoof() {
        return super.registryRoof;
    }
}
